/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { postCommBannerList } from "../../api/banner";
import { toast } from "wc-toast";

export default function BannerList() {
    const navigate = useNavigate();
    const location = useLocation();
    const initialBannerList = location.state?.bannerList || [];
    const [bannerList, setBannerList] = useState(initialBannerList);
    const [loading, setLoading] = useState(false);

    // 날짜 범위 유효성 체크
    const isBannerValid = (item) => {
        const todayStr = new Date().toISOString().split("T")[0];
        const { start_date, end_date } = item;

        if (start_date && end_date) {
            return todayStr >= start_date && todayStr <= end_date;
        }
        if (start_date && !end_date) {
            return todayStr >= start_date;
        }
        if (!start_date && end_date) {
            return todayStr <= end_date;
        }
        return true;
    };


    const handleBannerClick = async (item) => {
        if (item?.banner_seq) {
            try {
                await postCommBannerList({
                    banner_seq: String(item.banner_seq),
                    target_str: "click_cnt",
                });
            } catch (err) {
                console.error("배너 클릭 수 전송 실패:", err);
            }
        }
        if (item?.url) {
            window.open(item.url, "_blank", "noopener,noreferrer");
        }
    };



    return (
        <div className="mt-5">
            <div style={{ padding: "16px 10px 0 10px" }}>
                {bannerList && bannerList.length > 0 ? (
                    bannerList.map((item, index) => (
                        <div key={item.banner_seq || index} style={{ marginBottom: "12px" }}>
                            <img
                                src={item.banner_img}
                                alt={item.banner_title}
                                style={{
                                    width: "100%",
                                    height : "100px",
                                    borderRadius: "8px",
                                    display: "block",
                                    cursor: "pointer",
                                }}
                                onClick={() => handleBannerClick(item)}
                            />
                        </div>
                    ))
                ) : (
                    <div
                        className="text-center text-secondary"
                        style={{ marginTop: "60px", fontSize: "14px" }}
                    >
                        진행 중인 이벤트가 없습니다.
                    </div>
                )}
            </div>
        </div>
    );
}